
export class Availables {
  public id: number;
  public firstname: string;
  public lastname: string;
  public password: string;
  public card: string;
  public email: string;
  public telephone: string;
  // public role: string;
  public profile: string;
  public enabled: boolean;
  public bodyid: string;
  public tag: string;

  constructor(
    id: number,
    firstname: string,
    lastname: string,
    password: string,
    card: string,
    email: string,
    telephone: string,
    // role: string,
    profile: string,
    enabled: boolean,
    bodyid: string,
    tag: string
  ) {
    this.id = id;
    this.firstname = firstname;
    this.lastname = lastname;
    this.password = password;
    this.card = card;
    this.email = email;
    this.telephone = telephone;
    // this.role = role;
    this.profile = profile;
    this.enabled = enabled;
    this.bodyid = bodyid;
    this.tag = tag;
  }

}
